// key is Readable frontend key, value is KYC question codes from BFF (EBX)
export enum KycQuestionCodes {
  // Account Kyc Questions
  mainSourceOfFunds = 'MAIN_SOURCE_OF_FUNDS',
  traderOnAccount = 'ACCOUNT_CONTROLLED_BY_THIRD_PARTY_INDICATOR',
  anotherUserOnAccount = 'ACCOUNT_USED_BY_THIRD_PARTY_INDICATOR',
  authorizedConductOperations = 'ACCOUNT_CONTROLLED_BY_THIRD_PARTY_ROLE',

  // Investor Kyc Questions
  trustedContactPersonIndicator = 'TRUSTED_CONTACT_PERSON_INDICATOR',
  employeeIndicator = 'EMPLOYEE_INDICATOR',
  professionalIndicator = 'PROFESSIONAL_INDICATOR',
  hasAdminInvolvement = 'HAS_ADMIN_INVOLVEMENT',
  hasTenPercentInvolvement = 'HAS_TEN_PERCENT_INVOLVEMENT',
  hasTwentyPercentInvolvement = 'HAS_TWENTY_PERCENT_INVOLVEMENT',
}

export enum KycQuestionKeys {
  ACCOUNT_KYC_QUESTIONS = 'ipmAccountKycQuestions',
  INVESTOR_KYC_QUESTIONS = 'ipmInvestorKycQuestions',
}

/**
 * Single source of truth mapping a form/summary field name to its BFF KYC question code.
 * Reused by the form steps and the Summary to keep labels in sync.
 */
export const ACCOUNT_KYC_FIELD_TO_CODE = {
  fundingSource: KycQuestionCodes.mainSourceOfFunds,
  hasTraderOnAccount: KycQuestionCodes.traderOnAccount,
  hasAnotherUserOnAccount: KycQuestionCodes.anotherUserOnAccount,
  proxyType: KycQuestionCodes.authorizedConductOperations,
} as const;

export const INVESTOR_KYC_FIELD_TO_CODE = {
  hasTrustedContactPerson: KycQuestionCodes.trustedContactPersonIndicator,
  firmEmployeeQuestionInd: KycQuestionCodes.employeeIndicator,
  professionalQuestionInd: KycQuestionCodes.professionalIndicator,
  hasAdminInvolvement: KycQuestionCodes.hasAdminInvolvement,
  hasTenPercentInvolvement: KycQuestionCodes.hasTenPercentInvolvement,
  hasTwentyPercentInvolvement: KycQuestionCodes.hasTwentyPercentInvolvement,
} as const;
